module.exports = __webpack_public_path__ + "static/media/portfolio-image-1.448f188c.jpg";